import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectActiveFeatures,
  selectFeatureFlagsLoaded,
  selectIsFeatureActive
} from '@core/store/feature-flags/feature-flags.selectors';

/**
 * Developer entry point for feature gating. Inject this facade and call
 * `isActive(uid)` to get a reactive Signal<boolean> for the current dataspace.
 *
 * Example:
 *   private readonly flags = inject(FeatureFlagsFacade);
 *   protected readonly enabled = this.flags.isActive(KNOWN_FEATURE_FLAGS.SOME_FLAG);
 *   // template: @if (enabled()) { ... }
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagsFacade {
  private readonly store = inject(Store);

  readonly activeFeatures: Signal<string[]> = this.store.selectSignal(selectActiveFeatures);

  readonly loaded: Signal<boolean> = this.store.selectSignal(selectFeatureFlagsLoaded);

  isActive(uid: string): Signal<boolean> {
    return this.store.selectSignal(selectIsFeatureActive(uid));
  }
}
